import {
    ua,
    getRemoveNullObject,
    miniNav,
} from '@kkmh/utils'
import {
    logout,
    login,
    get_user,
} from '@kk/h5-sdk'
export const getPayParam = (opt = {}) => {
    return {
        //接口所需字段
        good_type           : opt.good_type || 0,               //必须-int 1.kkb 2.vip
        good_id             : opt.good_id || 0,                 //必须-int 76
        third_activity      : opt.third_activity || '',         //不必须-string （pay_info字段） 活动ID
        comic_id            : opt.comic_id || 0,                //不必须-int （pay_info字段） 漫画id
        topic_id            : opt.topic_id || 0,                //不必须-int （pay_info字段） 专题id
        source_type         : opt.source_type || 0,             //不必须-int （pay_info字段） 1：签到，2：皇冠，3：作品，4：礼包
        invite_code         : opt.invite_code || '',            //不必须-string （pay_info字段） 邀请码
        coupon_id           : opt.coupon_id || '',              //不必须-string （pay_info字段）【vip相关】输入优惠券id
        vip_source          : opt.vip_source || '',             //不必须-string （pay_info字段）【vip相关】get_entrance_param协议里获取的vip_source字段
        non_iap_supported   : opt.non_iap_supported || 0,       //不必须-int 运营位是否支持越狱，1表示支持
        //埋点所需字段
        cps                 : opt.cps || '',                    //不必须-string 下单接口时要传递的字段，也用作埋点上报
        trigger_page        : opt.trigger_page || '',           //不必须-string （track_info字段）埋点属性TriggerPage
        origin              : opt.origin || '',                 //不必须-string （track_info字段）埋点属性EntranceName
        notice_type         : opt.notice_type || '',            //不必须-string （track_info字段）【vip相关】get_entrance_param协议里获取的notice_type字段
        send_comic          : opt.send_comic || '',             //不必须-string （track_info字段）【vip相关】定向限免埋点-assign接口中send_comic字段
        free_pay_rate       : opt.free_pay_rate || '',          //不必须-string （track_info字段）【vip相关】定向限免埋点-assign接口中free_pay_rate字段
        trigger_item        : opt.trigger_item || '',           //不必须-string  (track_info字段) 会员日 TriggerItemName
        //回掉地址
        redirect_url        : opt.redirect_url || location.href,//不必须-string 支付成功之后想跳回的h5地址
        //小程序
        bind_phone          : opt.bind_phone === undefined ? 1 : opt.bind_phone,              //不必须-int 百度小程序支付前验证是否需要绑定手机号，默认：0 不绑定
        // 增加埋点字段
        activity_name       : opt.activity_name,
        popup_name          : opt.popup_name,
        topic_name          : opt.topic_name,
        puwid               : opt.puwid || "",
        activity_mark       : opt.activity_mark || '',
        pay_activity_name   : opt.pay_activity_name || ''
    }
}
export const getNativeInfo = (opt = {}) => {
    return new Promise(resolve => {
        (async () => {
            let nativeinfo = {};
            if (ua.kkmh) {
                nativeinfo = await window.getBaseInfoPromise.then();
            }
            let {sys={}, user={}} = nativeinfo;
            resolve({
                uid                         : user.id || 0,
                non_iap_supported_device    : sys.is_jailbroken_phone ? true : false, //是否越狱设备，true表示是
                device_id                   : sys.device_id || '',  //head头
                muid                        : sys.muid || '',       //head头
                app_info                    : sys.app_info || '',   //head头
                package_id                  : sys.package_id || '', //head头
            });
        })()
    })
}

export const getPayInfo = (opt) => {
    let pay_info = {
        comic_id        : opt.comic_id || 0,
        topic_id        : opt.topic_id || 0,
        source_type     : opt.source_type || '',
        invite_code     : opt.invite_code || '',
        vip_source      : opt.vip_source || '',
        coupon_id       : opt.coupon_id || '',
        third_activity  : opt.third_activity || '',
    };
    return getRemoveNullObject(pay_info) || {};
}

export const setTrack = (track_id) => {
    track_id = track_id ? track_id.toString() : '';    
    //初始化埋点信息
    if (typeof kksa != "undefined" && track_id) {
        kksa.identify(track_id);
        kksa.is_identified = true;
    }
}
const setUserSession = (session) => {
    if (session) {
        session.split(";").forEach((item) => {
            var domain = '';//获取一级域名(domain=.kuaikanmanhua.com;)
            if(/\.com|\.cn/.test(location.hostname)) {
                 domain = 'domain=.'+location.hostname.split('.').slice(-2).join('.')+';';
            }
            var Days = 15;
            var exp = new Date();
            exp.setTime(exp.getTime() + Days*24*60*60*1000);
            var cookie = item + ";"+ domain +"path=/;expires=" + exp.toGMTString()+"";
            document.cookie = cookie;
        });
    }
}
const getUserSession = () => {
    return new Promise(resolve => {
        get_user({
            callback: function (res) {
                let {data={}} = res;
                let session = '';
                // 老协议kkaction-getLoginInfo
                if(data.loginInfo) {
                    session = data.loginInfo;
                }
                // 新协议kkmhybrid-get_user
                if(data.session) {
                    session = data.session;   
                }
                resolve(session);
            }
        });
    })
}
export const jumpToLogin = () => {
    if (ua.kkmh) {
        return new Promise(resolve => {
            logout({
                callback : (res) => {
                    login({
                        callback : (res) => {
                            let {code, data={}, message} = res;
                            // 老协议
                            if (data.status == 0) {//没有登录
                                resolve(false);
                            }
                            if (data.status == 1) {//已登陆
                                getUserSession().then((session) => {
                                    setUserSession(session);
                                    resolve(true);
                                })
                            }

                            // 新协议：0->打开登录窗体 1->关闭登录窗口
                            if(data.path_step == 1) {
                                if (data.is_success_login == 0) {//没有登录
                                    resolve(false);
                                }
                                // 0-> 没有登录 1->登录成功
                                if (data.is_success_login == 1) {//已登陆
                                    getUserSession().then((session) => {
                                        setUserSession(session);
                                        resolve(true);
                                    })
                                }
                            }
                        }
                    })
                }
            })
        })
    } else if(ua.miniprogram) {
        return new Promise(resolve => {
            miniNav('/pages/login/login');
            // 不要resolve 小程序本身要跳转登录页，跳转耗时 resolve会导致上方await方法输出未登录error信息
            // resolve()
        })
    } else {
        let url = 'm.quickcan.cn/mob/login/?';
        if (ua['dev']) {
            url = 'dev-m.quickcan.cn/mob/login/?';
        }
        if (ua['prod']) {
            url = 'm.kuaikanmanhua.com/mob/login/?';
        }
        url = location.protocol + '//' + url + 'redirect=' + encodeURIComponent(window.location.href);
        location.href = url;
    }
}





// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/assets/utils.js